import { IOMACredential, IOMAImage } from '@/interfaces/iomaCredential';
import { PaginatedResponse } from '@/interfaces/response';
import { Note } from '@/interfaces/note';
import { AxiosPromise } from 'axios';
import request from '@/umi-request';

export async function uploadIomaCredential(affiliate: number, data: any) {
  return request({
    url: `affiliates/${affiliate}/ioma-credential/`,
    method: 'POST',
    data
  }) as AxiosPromise<IOMAImage>;
}

export async function uploadImage(affiliate: number, data: any) {
  return request({
    url: `affiliates/${affiliate}/ioma-credential/upload-image/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  }) as AxiosPromise<IOMACredential>;
}

export async function cancelIOMACredential(affiliate: number, id: number) {
  return request({
    url: `affiliates/${affiliate}/ioma-credential/${id}/cancel/`,
    method: 'POST'
  }) as AxiosPromise<IOMACredential>;
}

export async function updateIOMACredential(affiliate: number, id: number, data: any) {
  return request({
    url: `affiliates/${affiliate}/ioma-credential/${id}/update/`,
    method: 'PATCH',
    data
  }) as AxiosPromise<IOMACredential>;
}

export async function queryIOMACredencials(params: any) {
  return request({
    url: `ioma-credential/`,
    method: 'GET',
    params
  }) as AxiosPromise<PaginatedResponse<IOMACredential>>;
}

export async function queryIOMACredencial(id: number | string) {
  return request({
    url: `ioma-credential/${id}/`,
    method: 'GET',
  }) as AxiosPromise<IOMACredential>;
}

export async function updateIOMACredencialStatus(id: number | string, data: any) {
  return request({
    url: `ioma-credential/${id}/`,
    method: 'PATCH',
    data
  }) as AxiosPromise<IOMACredential>;
}

export async function queryIOMACredencialHistory(id: number | string) {
  return request({
    url: `ioma-credential/${id}/history/`,
    method: 'GET',
  }) as AxiosPromise<IOMACredential[]>;
}

export async function queryIOMACredencialChangesHistory(id: number | string) {
  return request({
    url: `ioma-credential/${id}/changes-history/`,
    method: 'GET',
  }) as AxiosPromise<IOMACredential[]>;
}

export async function sendIOMACredencialNote(id: number | string, data: { content: string }) {
  return request({
    url: `ioma-credential/${id}/notes/`,
    method: 'POST',
    data
  }) as AxiosPromise<Note<IOMACredential>>;
}

export async function getIOMACredencialNotes(id: number | string) {
  return request({
    url: `ioma-credential/${id}/notes/`,
    method: 'GET',
  }) as AxiosPromise<Note<IOMACredential>[]>;
}
